export const CLEAR_INVENTORY = 'promotions/CLEAR_INVENTORY'
export const MARK_ALL_INVENTORY_SEEN = 'promotions/MARK_ALL_INVENTORY_SEEN'
export const MARK_INVENTORY_ITEM_SEEN = 'promotions/MARK_INVENTORY_ITEM_SEEN'
export const REMOVE_INVENTORY_ITEM = 'promotions/REMOVE_INVENTORY_ITEM'
export const UPDATE_INVENTORY = 'promotions/UPDATE_INVENTORY'
export const UPDATE_INVENTORY_ITEM = 'promotions/UPDATE_INVENTORY_ITEM'
